import { render, staticRenderFns } from "./common-diseases.vue?vue&type=template&id=6f9e2d57&scoped=true"
import script from "./common-diseases.vue?vue&type=script&lang=js"
export * from "./common-diseases.vue?vue&type=script&lang=js"
import style0 from "./common-diseases.vue?vue&type=style&index=0&id=6f9e2d57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9e2d57",
  null
  
)

export default component.exports